<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Newsletter",
};
</script>

<style scoped></style>
